import { IS_DEV_ENV } from "utils/env";

// Small amber pill rendered next to the brand name on dev builds.
export function DevBadge({ className = "" }) {
  if (!IS_DEV_ENV) return null;
  return (
    <span
      className={`inline-flex items-center rounded-md bg-amber-500 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-widest text-white shadow-sm ${className}`}
    >
      Dev
    </span>
  );
}

// Full-width hazard ribbon pinned to the very top on dev builds.
export function DevRibbon() {
  if (!IS_DEV_ENV) return null;
  return (
    <div className="fixed top-0 inset-x-0 z-[60] h-6 flex items-center justify-center gap-1.5 whitespace-nowrap overflow-hidden bg-amber-500 text-white text-[11px] font-bold uppercase tracking-widest shadow-sm">
      <span>🚧 Development Environment</span>
      <span className="hidden sm:inline">— data may be reset or unstable</span>
    </div>
  );
}
